import { render, staticRenderFns } from "./TextSimple.vue?vue&type=template&id=ea596f36&scoped=true&"
import script from "./TextSimple.vue?vue&type=script&lang=js&"
export * from "./TextSimple.vue?vue&type=script&lang=js&"
import style0 from "./TextSimple.vue?vue&type=style&index=0&id=ea596f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea596f36",
  null
  
)

export default component.exports